import {
  greetingsTableQuery,
  greetingsTableRefreshed,
} from '@/entities/greetings'
import { type GreetingModel } from '@/shared/api'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { combine, createEvent, createStore, sample } from 'effector'

import { greetingsOrder } from '../api'

// Selection and order

export const greetingIdsOrderSet = createEvent<string[]>()

export const $greetingIdsOrder = createStore<string[]>([])
  .on(greetingIdsOrderSet, (_, ids) => ids)
  .on(greetingsTableQuery.finished.success, (_, { result }) =>
    result.items.map((greeting) => greeting.id),
  )

export const $greetingsReordered = combine(
  greetingsTableQuery.$data,
  $greetingIdsOrder,
  (data, order): GreetingModel[] => {
    if (!data || !data.items) return []
    if (!order.length) return data.items

    const map = new Map(data.items.map((greeting) => [greeting.id, greeting]))
    const reordered = order
      .map((id) => map.get(id))
      .filter((greeting): greeting is GreetingModel => !!greeting)

    return reordered
  },
)

export const $greetingsReorderBlocked = createStore(false)

sample({
  clock: greetingsOrder.start,
  fn: () => true,
  target: $greetingsReorderBlocked,
})

sample({
  clock: greetingsOrder.finished.success,
  fn: () => false,
  target: [$greetingsReorderBlocked, greetingsTableRefreshed],
})

sample({
  clock: greetingsOrder.finished.success,
  fn: () => {
    return {
      message: 'Приоритет приветственных экранов обновлён',
    }
  },
  target: showNotificationSuccessFx,
})
